import { useQuery } from '@tanstack/react-query';
import { searchEntities, type SearchResult } from '../api/search';

export function useGlobalSearch(query: string, enabled: boolean) {
  return useQuery<SearchResult[], Error>({
    queryKey: ['global-search', query],
    queryFn: () => searchEntities(query),
    enabled: enabled && query.trim().length > 1,
    staleTime: 1000 * 10,
  });
}
